import React from "react";

import { buildSaleItemDisplayLabel } from "../../views/salesUtils";

function SaleItemLabel({
  productTitle,
  variantTitle,
  optionSummary,
  className = "sp-item-label",
}) {
  const label = buildSaleItemDisplayLabel({
    productTitle,
    variantTitle,
    optionSummary,
  });

  return (
    <span className={className} title={label}>
      {label}
    </span>
  );
}

export default SaleItemLabel;
